import { PartialRealisationAllocationLogic } from 'further-types/lp/realisation';
import { round, sortBy } from 'lodash';
import { InvestmentHistory } from '../../types';

const allocateUnitsOrderedStrategy = (
  investmentHistory: InvestmentHistory,
  unitsSold: number,
  totalUnits: number,
  strategy:
    | PartialRealisationAllocationLogic.FIFO
    | PartialRealisationAllocationLogic.LIFO,
) => {
  if (!totalUnits || !unitsSold) {
    return investmentHistory.map((history) => ({
      ...history,
      allocatedUnits: 0,
    }));
  }

  const workingCopy = investmentHistory.map((history, index) => ({
    ...history,
    originalIndex: index,
  }));

  const sortedByDate = sortBy(workingCopy, (history) =>
    history.date.toUTCDate().getTime(),
  );

  const sortedHistory =
    strategy === PartialRealisationAllocationLogic.LIFO
      ? sortedByDate.reverse()
      : sortedByDate;

  let remainingUnitsToAllocate = unitsSold;

  const allocatedHistory = sortedHistory.map((history) => {
    const allocatedUnits = Math.min(
      remainingUnitsToAllocate,
      history.currentNumberOfUnits,
    );

    remainingUnitsToAllocate -= allocatedUnits;

    return {
      ...history,
      allocatedUnits: round(allocatedUnits, 2),
    };
  });

  const result = [...investmentHistory].map((_, index) => {
    const matchingItem = allocatedHistory.find(
      (h) => h.originalIndex === index,
    );
    return {
      ...investmentHistory[index],
      allocatedUnits: matchingItem ? matchingItem.allocatedUnits : 0,
    };
  });

  return result;
};

export default allocateUnitsOrderedStrategy;
